import axios from 'axios';

import { getBaseUrl, log } from 'common/utils';
import { ENV, VALID } from 'common/const';

import mock from './getEventSearchTags.mock';

const baseUrl = getBaseUrl(2);

/**
 * Get search tags for a specifc order
 * @param {string} eventId
 * @param {string} ooId
 * @returns list of search tags
 */
const getEventSearchTags = async ({ eventId, ooId }) => {
  await VALID.checkAll(
    ['eventId', eventId, VALID.EVENT_ID],
    ['ooId', ooId, VALID.OO_SUMMARY_ID],
  );

  try {
    const { data } = ENV.IS_MOCK
      ? mock()
      : await axios.get(`${baseUrl}events/search_tags/${ooId}/${eventId}`);

    return data.searchTags;
  } catch (error) {
    log('getEventSearchTags', {
      data: { eventId, ooId },
      error,
      throw: true,
      type: 'request',
    });
  }
};

export default getEventSearchTags;
